import { DateService } from '@rocheglobal/component-library-dot-com/src/services/date';
import React, { useEffect, useState } from 'react';
import {
  PageItem,
  PageItems,
  LanguageService,
  TeaserService,
} from '../../services';
import { ConditionalWrapper } from '../helpers';
import { parseAssetSource } from '../props/asset';
import { Props } from '../types';

interface RocheTeaserAutoState {
  teasers: PageItems;
}

const initialState: RocheTeaserAutoState = {
  teasers: {} as PageItems,
};

export const RocheTeaserAuto = ({
  blok,
  updateHoistedState,
  slot,
  wrapperTag,
}: Props): JSX.Element => {
  const [state, setState] = useState<RocheTeaserAutoState>(initialState);
  const Wrapper = wrapperTag as React.ElementType;

  useEffect(() => {
    const {
      group_tags: groupTags,
      page,
      sorting,
      tags,
      teaser_number: number,
    } = blok;

    if (!sorting || !number || [...tags, ...groupTags].length <= 0) {
      return;
    }

    TeaserService.getTeasers(tags, groupTags, sorting, (page || 1), number)
      .then(async (result) => {
        const itemsWithDate = await Promise.all(result.items.map(
          async (teaser: PageItem) => ({
            ...teaser,
            first_published_at: await DateService.formatDate(teaser?.first_published_at as string | Date, 'dateFull'),
          }),
        ));

        setState({
          teasers: {
            ...result,
            items: itemsWithDate,
          },
        });
        return updateHoistedState?.(result.items.length, result.total, `${tags}${groupTags}`, result);
      });
  }, []);

  if (Object.keys(state.teasers).length <= 0) { return null; }
  return <>
    {state.teasers
      .items
      .map((teaser: PageItem, index: number) => (
        <ConditionalWrapper
          key={index}
          condition={wrapperTag !== undefined && wrapperTag !== ''}
          wrapper={(children: JSX.Element): JSX.Element => (
            <Wrapper slot={slot}>{children}</Wrapper>
          )}
        >
          <roche-teaser
            key={index}
            layout={blok.layout}
            teaser-image={parseAssetSource(teaser.content?.teaser_image[0]?.src.filename)}
            teaser-title={teaser.content?.teaser_title}
            teaser-overline={teaser.content?.teaser_overline}
            teaser-description={teaser.content?.teaser_description}
            teaser-date={teaser.first_published_at}
            teaser-url={
              LanguageService.getLocaleAwareLink(
                teaser?.default_full_slug,
                LanguageService.getParsedLocale(
                  LanguageService.getActiveLanguage(),
                ),
              )
            }
            loaded={teaser.content !== undefined}
            slot={slot}
          >
          </roche-teaser>
        </ConditionalWrapper>
      ))}
  </>;
};
